import { useGetLicenceByIdQuery } from "@sso/apis/licences";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { LicenceKeys } from "@sso/types";

import { DialogBody, DialogHeader } from "../components";
import TraccAdditionalData from "./AdditionalData/tracc";

const LicenceInfoDialog = () => {
    const { id } = useAppSelector(selectDialog);
    if (!id) {
        throw new Error("LicenceInfoDialog: id is null");
    }
    const { data, isSuccess } = useGetLicenceByIdQuery(id);
    const type = data?.[LicenceKeys.ADDITIONAL_DATA]?.type.toUpperCase() || "DEFAULT";

    const buildTitle = (type: string) => {
        switch (type) {
            case "TRACC":
                return "TRACC Licence Additional Info";
            default:
                return "Licence Additional Info";
        }
    };

    return <>
        {isSuccess && data && (
            <>
                <DialogHeader title={buildTitle(type)} />
                <DialogBody>
                    {
                        (() => {
                            switch (type) {
                                case "TRACC":
                                    return <TraccAdditionalData additionalData={data[LicenceKeys.ADDITIONAL_DATA]} licence={data} />;
                                default:
                                    return <p>No additional data available.</p>;
                            }
                        })()
                    }</DialogBody>
            </>
        )}
    </>;
};

export default LicenceInfoDialog;
